import { css, keyframes } from '@emotion/react';
import styled from '@emotion/styled';

const shine = keyframes`
    0% {
        background-position: 100%;
    }

    100% {
        background-position: 0%;
    }
`;

export const Skeleton = styled('div')(css`
    position: relative;

    &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;

        background: linear-gradient(
            90deg,
            rgba(0, 0, 0, 0) 35%,
            rgba(255, 255, 255, 0.3) 50%,
            rgba(0, 0, 0, 0) 65%
        );
        background-size: 300%;
        animation: ${shine} 1.5s linear infinite;
    }
`);

export const SkeletonBlock = styled('div')(
    ({ theme: { spacing } }) => css`
        ${SkeletonRow} {
            margin-bottom: ${spacing['16px']};

            &:last-child {
                margin-bottom: 0;
            }
        }
    `
);

export const SkeletonRow = styled('div')<{
    spacing?: number;
    itemHeight?: number;
}>(
    ({ itemHeight = 3, spacing = 1, theme }) => css`
        display: flex;

        ${SkeletonItem} {
            margin-right: calc(${theme.spacing['8px']}*${spacing});
            height: calc(${theme.spacing['8px']}*${itemHeight});

            &:last-child {
                margin-right: 0;
            }
        }
    `
);

export const SkeletonItem = styled('div')<{ size: number }>(
    ({ theme: { borderRadius, colors, spacing }, size }) => css`
        width: calc(${spacing['8px']}*${size});
        background: ${colors['graphic-background-accent']};
        border-radius: ${borderRadius['8px']};
    `
);
